import {
  createItem as publicCreateItem,
  getItem as publicGetItem,
  updateItem as publicUpdateItem,
  deleteItem as publicDeleteItem,
  queryItems as publicQueryItems,
  typedQueryItems as publicTypedQueryItems,
  updateExtendedFields as publicUpdateExtendedFields,
  bulkCreateItems as publicBulkCreateItems,
  bulkUpdateItems as publicBulkUpdateItems,
  bulkDeleteItems as publicBulkDeleteItems,
  removeItemFromTrashBin as publicRemoveItemFromTrashBin,
  restoreItemFromTrashBin as publicRestoreItemFromTrashBin,
  getDeletedItem as publicGetDeletedItem,
  listDeletedItems as publicListDeletedItems,
} from './fastgallery-item-v1-item-items.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { BuildRESTFunction, MaybeContext } from '@wix/sdk-types';
import { HttpClient } from '@wix/sdk-types';
import { createQueryOverloadRouter } from '@wix/sdk-runtime/query-method-router';
import {
  ItemQuery,
  ItemsQueryBuilder,
  typedQueryItems as universalTypedQueryItems,
} from './fastgallery-item-v1-item-items.universal.js';

function customQueryItems(httpClient: HttpClient) {
  const router = createQueryOverloadRouter({
    builderQueryFunction: () => publicQueryItems(httpClient)(),
    typedQueryFunction: (query: ItemQuery) =>
      publicTypedQueryItems(httpClient)(query),
    hasOptionsParameter: false,
  });

  function overloadedQuery(): ItemsQueryBuilder;
  function overloadedQuery(
    query: ItemQuery
  ): ReturnType<typeof universalTypedQueryItems>;
  function overloadedQuery(query?: ItemQuery): any {
    return router(...arguments);
  }

  return overloadedQuery;
}

export const createItem: MaybeContext<
  BuildRESTFunction<typeof publicCreateItem> & typeof publicCreateItem
> = /*#__PURE__*/ createRESTModule(publicCreateItem);
export const getItem: MaybeContext<
  BuildRESTFunction<typeof publicGetItem> & typeof publicGetItem
> = /*#__PURE__*/ createRESTModule(publicGetItem);
export const updateItem: MaybeContext<
  BuildRESTFunction<typeof publicUpdateItem> & typeof publicUpdateItem
> = /*#__PURE__*/ createRESTModule(publicUpdateItem);
export const deleteItem: MaybeContext<
  BuildRESTFunction<typeof publicDeleteItem> & typeof publicDeleteItem
> = /*#__PURE__*/ createRESTModule(publicDeleteItem);
export const updateExtendedFields: MaybeContext<
  BuildRESTFunction<typeof publicUpdateExtendedFields> &
    typeof publicUpdateExtendedFields
> = /*#__PURE__*/ createRESTModule(publicUpdateExtendedFields);
export const bulkCreateItems: MaybeContext<
  BuildRESTFunction<typeof publicBulkCreateItems> & typeof publicBulkCreateItems
> = /*#__PURE__*/ createRESTModule(publicBulkCreateItems);
export const bulkUpdateItems: MaybeContext<
  BuildRESTFunction<typeof publicBulkUpdateItems> & typeof publicBulkUpdateItems
> = /*#__PURE__*/ createRESTModule(publicBulkUpdateItems);
export const bulkDeleteItems: MaybeContext<
  BuildRESTFunction<typeof publicBulkDeleteItems> & typeof publicBulkDeleteItems
> = /*#__PURE__*/ createRESTModule(publicBulkDeleteItems);
export const removeItemFromTrashBin: MaybeContext<
  BuildRESTFunction<typeof publicRemoveItemFromTrashBin> &
    typeof publicRemoveItemFromTrashBin
> = /*#__PURE__*/ createRESTModule(publicRemoveItemFromTrashBin);
export const restoreItemFromTrashBin: MaybeContext<
  BuildRESTFunction<typeof publicRestoreItemFromTrashBin> &
    typeof publicRestoreItemFromTrashBin
> = /*#__PURE__*/ createRESTModule(publicRestoreItemFromTrashBin);
export const getDeletedItem: MaybeContext<
  BuildRESTFunction<typeof publicGetDeletedItem> & typeof publicGetDeletedItem
> = /*#__PURE__*/ createRESTModule(publicGetDeletedItem);
export const listDeletedItems: MaybeContext<
  BuildRESTFunction<typeof publicListDeletedItems> &
    typeof publicListDeletedItems
> = /*#__PURE__*/ createRESTModule(publicListDeletedItems);
export const queryItems: MaybeContext<
  BuildRESTFunction<typeof customQueryItems> & typeof customQueryItems
> = /*#__PURE__*/ createRESTModule(customQueryItems);

export {
  LinkType,
  LinkRel,
  Type,
  SortOrder,
  WebhookIdentityType,
} from './fastgallery-item-v1-item-items.universal.js';
export {
  Item,
  Link,
  WixLink,
  WixLinkLinkOneOf,
  ExternalLink,
  PageLink,
  AnchorLink,
  DynamicPageLink,
  DocumentLink,
  EmailLink,
  PhoneLink,
  AddressLink,
  WhatsAppLink,
  TpaPageLink,
  MediaItem,
  MediaItemMediaOneOf,
  Image,
  FocalPoint,
  Point,
  UnsharpMasking,
  ExtendedFields,
  CreateItemRequest,
  CreateItemResponse,
  GetItemRequest,
  GetItemResponse,
  UpdateItemRequest,
  UpdateItemResponse,
  DeleteItemRequest,
  DeleteItemResponse,
  QueryItemsRequest,
  CursorQuery,
  CursorQueryPagingMethodOneOf,
  Sorting,
  CursorPaging,
  QueryItemsResponse,
  CursorPagingMetadata,
  Cursors,
  UpdateExtendedFieldsRequest,
  UpdateExtendedFieldsResponse,
  BulkCreateItemsRequest,
  BulkCreateItemsResponse,
  ItemMetadata,
  ApplicationError,
  BulkItemResult,
  BulkActionMetadata,
  BulkUpdateItemsRequest,
  MaskedItem,
  BulkUpdateItemsResponse,
  BulkUpdateItemsResponseBulkItemResult,
  BulkDeleteItemsRequest,
  BulkDeleteItemsResponse,
  BulkDeleteItemsResponseBulkItemResult,
  RemoveItemFromTrashBinRequest,
  RemoveItemFromTrashBinResponse,
  RestoreItemFromTrashBinRequest,
  RestoreItemFromTrashBinResponse,
  GetDeletedItemRequest,
  GetDeletedItemResponse,
  ListDeletedItemsRequest,
  ListDeletedItemsResponse,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  Empty,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  AccountInfo,
  UpdateItem,
  ItemsQueryResult,
  ItemsQueryBuilder,
  ItemQuerySpec,
  UpdateExtendedFieldsOptions,
  BulkCreateItemsOptions,
  BulkUpdateItemsOptions,
  ListDeletedItemsOptions,
} from './fastgallery-item-v1-item-items.universal.js';
export { utils } from './fastgallery-item-v1-item-items.universal.js';
export {
  LinkTypeWithLiterals,
  LinkRelWithLiterals,
  TypeWithLiterals,
  SortOrderWithLiterals,
  WebhookIdentityTypeWithLiterals,
  CommonQueryWithEntityContext,
  ItemQuery,
} from './fastgallery-item-v1-item-items.universal.js';
